export const INITIAL_PRODUCTS = [
  {
    id: "1",
    label: "DeepStation Alpha X",
    price: 1250.00,
    brand: "DeepVision",
    category: "Workstations",
    ref: "DV-ALPHA-001",
    summary: "Station de travail pour l'IA et le Deep Learning.",
    images: ["https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?auto=format&fit=crop&q=80&w=800"],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    stock: 12,
    warranty: "3 ans sur site",
    description: "La DeepStation Alpha X est conçue pour les calculs intensifs. Équipée de processeurs neuronaux avancés.",
    weight: 15.5, height: 450, length: 500, width: 210, volume: 0.047
  },
  {
    id: "2",
    label: "VisionLens Pro 4K",
    price: 499.00,
    brand: "OpticFlow",
    category: "Caméras",
    ref: "OF-VL4K-PRO",
    summary: "Capteur d'image haute résolution pour l'industrie.",
    images: ["https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&q=80&w=800"],
    videoUrl: "",
    stock: 45,
    warranty: "2 ans retour atelier",
    description: "Capteur intelligent 4K optimisé pour l'inspection de précision.",
    weight: 0.8, height: 60, length: 120, width: 60, volume: 0.0004
  },
  {
    id: "3",
    label: "Tube Inox Industriel",
    price: 45.00,
    brand: "SteelMaster",
    category: "Matériaux",
    ref: "SM-TUBE-INOX",
    summary: "Tubes en acier inoxydable haute qualité.",
    images: ["https://images.unsplash.com/photo-1535813548-6601f6945362?auto=format&fit=crop&q=80&w=800"],
    isMatrix: true,
    options: [
      { name: "Inox", values: [{label: "304"}, {label: "316"}, {label: "316L"}] },
      { name: "Diamètre", values: [{label: "10mm"}, {label: "12mm"}, {label: "15mm"}, {label: "20mm"}, {label: "25mm"}] },
      { name: "Longueur", values: [{label: "100mm"}, {label: "200mm"}, {label: "500mm"}, {label: "1000mm"}, {label: "2000mm"}] }
    ],
    stockMap: {
      "304|10mm|100mm": 150,
      "316|12mm|500mm": 45,
      "316L|20mm|1000mm": 12
    },
    stock: 207,
    description: "Tubes inox de précision pour applications industrielles et alimentaires.",
    weight: 2.5, height: 20, length: 2000, width: 20, volume: 0.0008
  },
  {
    id: "4",
    label: "Capteur CMOS Industrial",
    price: 350.00,
    brand: "VisionTech",
    category: "Capteurs",
    ref: "VT-CMOS-IND",
    summary: "Capteur CMOS haute performance pour vision industrielle.",
    images: ["https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=800"],
    stock: 28,
    warranty: "2 ans",
    description: "Capteur CMOS dernière génération avec excellente sensibilité.",
    weight: 0.5, height: 50, length: 100, width: 50, volume: 0.00025
  },
  {
    id: "5",
    label: "Objectif Macro 50mm",
    price: 280.00,
    brand: "OpticsPlus",
    category: "Optiques",
    ref: "OP-MAC-50",
    summary: "Objectif macro pour inspection de précision.",
    images: ["https://images.unsplash.com/photo-1606189934846-a527c01d1e05?auto=format&fit=crop&q=80&w=800"],
    stock: 15,
    warranty: "3 ans",
    description: "Objectif macro professionnel pour applications industrielles.",
    weight: 0.6, height: 80, length: 120, width: 80, volume: 0.00077
  },
  {
    id: "6",
    label: "Éclairage LED Annulaire",
    price: 165.00,
    brand: "LightMaster",
    category: "Éclairage",
    ref: "LM-LED-RING",
    summary: "Éclairage LED annulaire pour vision industrielle.",
    images: ["https://images.unsplash.com/photo-1558089687-7b4d5d5d5d85?auto=format&fit=crop&q=80&w=800"],
    stock: 35,
    warranty: "2 ans",
    description: "Éclairage LED haute intensité avec contrôle précis de l'intensité.",
    weight: 0.4, height: 30, length: 150, width: 150, volume: 0.00068
  },
  {
    id: "7",
    label: "Logiciel Vision Pro",
    price: 850.00,
    brand: "DeepVision",
    category: "Logiciels",
    ref: "DV-SOFT-PRO",
    summary: "Suite logicielle complète pour vision industrielle.",
    images: ["https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800"],
    stock: 100,
    warranty: "1 an de support",
    description: "Logiciel professionnel d'analyse d'image et de contrôle qualité.",
    weight: 0.1, height: 10, length: 120, width: 100, volume: 0.00012
  },
  {
    id: "8",
    label: "Câble USB 3.0 Vision",
    price: 25.00,
    brand: "CableTech",
    category: "Câbles",
    ref: "CT-USB3-VIS",
    summary: "Câble USB 3.0 haute vitesse pour caméras industrielles.",
    images: ["https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=800"],
    stock: 150,
    warranty: "1 an",
    description: "Câble USB 3.0 blindé de qualité industrielle, 5 mètres.",
    weight: 0.2, height: 20, length: 5000, width: 10, volume: 0.001
  },
  {
    id: "9",
    label: "Filtre Polarisant Industrial",
    price: 95.00,
    brand: "OpticsPlus",
    category: "Filtres",
    ref: "OP-POLAR-IND",
    summary: "Filtre polarisant pour éliminer les reflets.",
    images: ["https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?auto=format&fit=crop&q=80&w=800"],
    stock: 42,
    warranty: "2 ans",
    description: "Filtre polarisant haute qualité pour applications exigeantes.",
    weight: 0.1, height: 5, length: 60, width: 60, volume: 0.000018
  },
  {
    id: "10",
    label: "Support Caméra Articulé",
    price: 120.00,
    brand: "MountPro",
    category: "Supports",
    ref: "MP-ARM-CAM",
    summary: "Bras articulé robuste pour montage caméra.",
    images: ["https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=800"],
    stock: 22,
    warranty: "3 ans",
    description: "Support articulé en aluminium avec fixation universelle.",
    weight: 1.8, height: 300, length: 450, width: 150, volume: 0.02025
  },
  {
    id: "11",
    label: "Contrôleur d'Éclairage",
    price: 210.00,
    brand: "LightMaster",
    category: "Contrôleurs",
    ref: "LM-CTRL-LED",
    summary: "Contrôleur programmable pour systèmes d'éclairage.",
    images: ["https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=800"],
    stock: 18,
    warranty: "2 ans",
    description: "Contrôleur 4 canaux avec interface RS-232 et Ethernet.",
    weight: 0.8, height: 60, length: 180, width: 120, volume: 0.001296
  },
  {
    id: "12",
    label: "Caméra Linéaire 4K",
    price: 1850.00,
    brand: "VisionTech",
    category: "Caméras",
    ref: "VT-LINE-4K",
    summary: "Caméra linéaire haute résolution pour inspection continue.",
    images: ["https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&q=80&w=800"],
    stock: 8,
    warranty: "3 ans",
    description: "Caméra linéaire 4K avec sortie GigE et Camera Link.",
    weight: 1.2, height: 100, length: 200, width: 80, volume: 0.0016
  }
];
